import { MessageReply } from './message-reply.model';
import { User } from './user.model';

export enum FromRole {
  Lender = 'lender',
  FundingDesk = 'fundingDesk',
  FundingManager = 'fundingManager',
}

export enum ToRole {
  Lender = 'lender',
  FundingDesk = 'fundingDesk',
  FundingManager = 'fundingManager',
}

// Represents a message sent:
// 1. Between a Partner Portal Lender User and a Funding Desk User
// 2. Between a Funding Manager user in Partner Portal and a Funding Desk User
export interface Message {
  id: number;
  borrowerId: number;
  dealId: number | null;
  description: string | null;
  completed: string | null;
  fromRole: FromRole;
  toRole: ToRole;
  created: string;
  modified: string;
  deleted: null;
  createdTimestamp: number;
  modifiedTimestamp: number;
  creator_user: User;
  task_comments: MessageReply[];
}
